import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';

import { TSegment } from '../types';

import { segmentsQueryKeys } from './query-keys';

export async function getSegmentId(id: string): Promise<TSegment> {
  return mediaManagerClient.get(`/api/v1/segments/${id}`).then(({ data }) => data);
}

type QueryFnType = typeof getSegmentId;

interface UseSegmentIdParams {
  config?: QueryConfig<QueryFnType>;
  id: string;
}

export function useGetSegmentId({ config, id }: UseSegmentIdParams) {
  return useQuery({
    ...config,
    enabled: !!id,
    queryKey: segmentsQueryKeys.id(id),
    queryFn: () => getSegmentId(id),
  });
}
